import { Component } from '@angular/core';
import { AlertController, NavController, NavParams, Platform } from 'ionic-angular';
import { LoginPage } from '../auth/login/login';
import { User } from '../../entities/user';
import { AppVersion } from '@ionic-native/app-version';
import { Shared } from '../../providers/shared';
import { SpinnerDialog } from '@ionic-native/spinner-dialog';


@Component({
    selector: 'page-settings',
    templateUrl: 'settings.html',
})
export class SettingsPage {

    user: User;
    version: string = '1.0.4';

    constructor(
        private alertCtrl: AlertController,
        private appVersion: AppVersion,
        private navCtrl: NavController,
        private navParams: NavParams,
        private platform: Platform,
        private shared: Shared,
        private spinner: SpinnerDialog,
    ) {
    }

    public ngAfterViewInit() {
        this.user = this.navParams.get('user');

        if (this.platform.is('cordova'))
            this.platform.ready().then(async () => {
                this.version = await this.appVersion.getVersionNumber();
            });
    }

    logout() {
        let alert = this.alertCtrl.create({
            title: 'Confirm Logout',
            message: 'Are you sure you want to logout?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                    }
                },
                {
                    text: 'Confirm',
                    handler: () => {
                        this.doLogout();
                    }
                }
            ]
        });
        alert.present();
    }

    async doLogout() {
        this.spinner.show();
        await this.shared.unsetAndRemove('apiToken');
        await this.shared.unsetAndRemove('user');
        this.spinner.hide();
        this.navCtrl.setRoot(LoginPage, {}, {animate: true, direction: 'back'});
    }

}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts